<template>
  <div class="hello">
    <div class="helloTop">
      <div class="OneTop">客户说</div>
      <div class="Two">
        <div v-for="(item, i) in items" :key="i" class="TwoTop">
          <div
            style="
              font-size: 14px;
              color: #909399;
              padding: 0 24px;
              margin-top: 75px;
            "
          >
            {{ item.title }}
          </div>
          <div
            style="
              width: 30px;
              border: 1px solid #b4d9fb;
              position: absolute;
              bottom: 130px;
              left: 24px;
            "
          ></div>
          <div
            style="
              width: 336px;
              border: 1px solid rgba(180, 217, 251, 0.4);
              position: absolute;
              bottom: 130px;
              left: 24px;
            "
          ></div>
          <div
            style="
              color: #8f959a;
              font-size: 14px;
              position: absolute;
              bottom: 75px;
              right: 24px;
            "
          >
            {{ item.conment }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Costing',
  data() {
    return {
      items: [
        {
          img: require('../assets/HelloWorld/anquan_b.png'),

          title:
            '大米智课为云学院量身定制的APP，帮助我们在线统一管理员工培训，考试和晋升，解决了异地管理存在的问题，极大的提高了效率。',
          conment: '—— 沃尔沃汽车大中华区销售公司副总裁',
        },
        {
          img: require('../assets/HelloWorld/anquan_a.png'),

          title:
            '大米智课的直播、OMO培训等功能，成功让我们将传统优势线下教育向线上延伸获得了潜在的合作机会和后续业务发展的启发',
          conment: '—— 今日教育副总裁',
        },
        {
          img: require('../assets/HelloWorld/anquan_d.png'),

          title:
            '大米智课帮助我们补全了移动端缺失这一块短板，通过分销市场将课程分发给合作伙伴，实现了多方共赢',
          conment: '—— 硕学教育副总裁',
        },
      ],
    }
  },
}
</script>

<style scoped lang="scss">
.hello {
  // height: 692px;
  width: 1440px;
  .helloTop {
    padding: 0 120px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 33px 0 0;
    .OneTop {
      height: 45px;
      font-size: 40px;
      font-weight: 500;
      color: #121221;
      line-height: 45px;
      margin: 50px 0 50px 0;
    }
    .OneLeft {
      height: 26px;
      font-size: 20px;
      font-weight: 400;
      color: #666666;
      line-height: 26px;
      margin: 0 0 14px;
    }
    .Top {
      margin: 0 0 50px;
    }
  }
  .Two {
    height: 300px;
    width: 1200px;
    display: flex;
    justify-content: space-between;
    // .TwoTop:hover {
    //   background: linear-gradient(180deg, #ffefe5 0%, #ffffff 50%);
    //   box-shadow: 0px 0px 22px 0px rgba(0, 51, 120, 0.3);
    //   border: 1px solid #f5f6f7;
    // }
    // .TwoTop:hover .bossOk {
    //   width: 100%;
    // }
    .TwoTop {
      position: relative;
      width: 384px;
      height: 297px;
      display: flex;
      flex-direction: column;
      align-items: center;
      // border: 1px solid #e6e6e6;
      box-sizing: border-box;
      // background-color: #ebf7ff;
      background-image: url('../assets//official/Group\ 48023.png');
      padding-bottom: 40px;
      background-size: 100% 100%;
      // border-radius: 8px;
      .bossOk {
        position: absolute;
        height: 2px;
        background: #eb5b05;
        width: 0;
        top: 0;
        transition: all 0.3s;
      }
      img {
        width: 82px;
        // height: 100px;
        margin-top: 46px;
        margin-bottom: 26px;
      }
      .TwoBoss {
        height: 40px;
        font-size: 24px;
        font-weight: 500;
        color: #333333;
        line-height: 40px;
        margin-bottom: 22px;
      }
      .TwoYou {
        width: 245px;
        font-size: 14px;
        color: #929292;
        text-align: center;
        padding: 25px 0 0;
        border-top: 1px solid #e6e6e6;
        box-sizing: border-box;
      }
    }
  }
}
</style>
